export const BulkActionEndpoints = {
    publish() {
        return `${process.env.API_CLUB_CONTENT}/v4/pages/published`;
    },
    delete() {
        return `${process.env.API_CLUB_CONTENT}/v4/content/deleted`;
    }
};
export const PageActionEndpoints = {
    duplicatePage() {
        return `${process.env.API_CLUB_CONTENT}/v1/content-duplication/page`;
    },
    renamePage(pageId) {
        return `${process.env.API_CLUB_CONTENT}/v4/pages/${pageId}/name`;
    },
    reorderPage(pageId) {
        return `${process.env.API_CLUB_CONTENT}/v4/pages/${pageId}/order`;
    }
};
export const ModuleActionEndpoints = {
    renameModule(moduleId) {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/${moduleId}/name`;
    },
    reorderModule(moduleId) {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/${moduleId}/order`;
    },
    duplicateModule() {
        return `${process.env.API_CLUB_CONTENT}/v1/content-duplication/module`;
    }
};
export const ContentListEndpoints = {
    getModules() {
        return `${process.env.API_CLUB_CONTENT}/v4/modules`;
    },
    getPages(moduleId) {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/${moduleId}/pages`;
    },
    waitContentDuplication(contextId) {
        return `${process.env.CLUB_WS}?context=SingleContentDuplication&contextId=${contextId}`;
    }
};
